<template>
  <div class="content-grid">
    <h1 class="util--screen-reader">{{ t("routes.coproperty.name") }}</h1>

    <Card :title="t('global.quickLinks')" class="card--row-content">
      <BtnLink
          :name="t('routes.coproperty.children.addDocument.name')"
          :path="{ 'name': 'coproperty.children.addDocument' }"/>
    </Card>

    <div class="content-grid content-grid--triple content-grid--triple-small-right">
      <Card :title="t('coproperty.recentDocs')">
        <DocumentsTable
            :documents="recentDocuments"
            :is-loading="documentsAreLoading"
            @documents-updated="loadAllDocuments"/>
      </Card>
      <Card :title="t('coproperty.allDocs')">
        <BtnLink v-for="documentCategory in documentCategoryLabelsAndSlugs" :key="documentCategory"
                 :name="documentCategory.label"
                 :path="{ 'name': 'coproperty.children.documentCategory', 'params': { 'documentCategorySlug': documentCategory.slug } }"/>
      </Card>
      <Card :title="t('coproperty.favoriteDocs')">
        <DocumentsTable
            :documents="favoriteDocuments"
            :is-loading="documentsAreLoading"
            @documents-updated="loadAllDocuments"/>
      </Card>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Card from '@/components/layout/Card.vue';
import BtnLink from '@/components/layout/BtnLink.vue';
import {DocumentCategoryHelper} from "@/types";
import {useI18n} from "vue3-i18n";
import {computed, onMounted, ref} from "vue";
import DocumentsTable from '@/components/tables/DocumentsTable.vue';
import {useDocumentService} from "@/inversify.config";
import {Document} from "@/types/entities/document";

const {t} = useI18n()

const documentService = useDocumentService();

const recentDocuments = ref<Document[]>([]);
const favoriteDocuments = ref<Document[]>([]);
const documentsAreLoading = ref(false)

const documentCategoryLabelsAndSlugs = computed(() =>
  DocumentCategoryHelper.categoriesLabelAndSlug().sort((a, b) => a.label > b.label ? 1 : -1))

onMounted(async () => {
  await loadAllDocuments()
})

async function loadAllDocuments() {
  documentsAreLoading.value = true;
  recentDocuments.value = [];
  favoriteDocuments.value = [];

  let documents = await documentService.getAllDocuments();
  if (documents && documents.length > 0) {
    recentDocuments.value = documents
      .sort((a: any, b: any) => Date.parse(b.creationDate) - Date.parse(a.creationDate))
    favoriteDocuments.value = documents.filter((x: Document) => x.favoriteDocumentId != null)
  }
  documentsAreLoading.value = false;
}
</script>
